<template>
    <div class="OrderAddress-root">
        <block-title
            title="发货地信息"
            class="origin-station"
            :show-line="false"
            icon-title="发"
        >
            <!-- <span slot="icon-right" class="icon-show" @click="onStartShow">
                {{startShow ? '收起' : '展开'}}
                <a-icon v-if="startShow" type="caret-up" />
                <a-icon v-else type="caret-down" />
            </span> -->
            <div v-if="startShow">
                <div
                    v-for="item in startStation"
                    :key="item.stationId"
                    class="station-info"
                >
                    <div>
                        <h3 class="station-name">{{item.stationName}}</h3>
                    </div>
                    <div class="station-container flex">
                        <div class="station-contact">
                            <img src="@/assets/img/contacts.png" alt="">
                            <template v-if="orderDetail.ext && orderDetail.ext.demoData">
                                {{item.contactName ?item.contactName.slice(0, 1)+'**' : '--'}}
                                {{item.contactPhone ? item.contactPhone.slice(0, 3)+'****'+item.contactPhone.slice(item.contactPhone.length-4,item.contactPhone.length) : '--'}}
                            </template>
                            <template v-else>
                                {{item.contactName}}
                                {{item.contactPhone}}
                            </template>
                        </div>
                        <div class="station-address">
                            <img src="@/assets/img/addrress_icon.png" alt="">
                            {{item.fullAddress}}
                        </div>
                        <div class="station-time">
                            <img src="@/assets/img/tips_icon.png" alt="">
                            要求取货时间 {{item.startTime | formatTimestamp}}
                        </div>
                    </div>
                </div>
            </div>
        </block-title>
        <block-title
            title="收货地信息"
            class="end-station"
            :show-line="false"
            icon-title="收"
        >
            <!-- <span slot="icon-right" class="icon-show" @click="onEndShow">
                {{endShow ? '收起' : '展开'}}
                <a-icon v-if="endShow" type="caret-up" />
                <a-icon v-else type="caret-down" />
            </span> -->
            <div v-if="endShow">
                <div 
                    v-for="(item, index) in endStations"
                    :key="index"
                    class="station-info"
                >
                    <div class="station-status flex">
                        <h3 class="station-name">{{item[0].stationName}}</h3>
                        <span
                            :class="['status', filterSign(item).statusClass]">
                            {{filterSign(item).label}}
                        </span>
                    </div>
                    <div class="station-container flex">
                        <div class="station-contact">
                            <img src="@/assets/img/contacts.png" alt="">
                            <template v-if="orderDetail.ext && orderDetail.ext.demoData">
                                {{item[0].contactName ? item[0].contactName.slice(0, 1)+'**' : '--'}}
                                {{item[0].contactPhone ? item[0].contactPhone.slice(0, 3)+'****'+item[0].contactPhone.slice(item[0].contactPhone.length-4,item[0].contactPhone.length) : '--'}}
                            </template>
                            <template v-else>
                                {{item[0].contactName}}
                                {{item[0].contactPhone}}
                            </template>
                        </div>
                        <div class="station-address">
                            <img src="@/assets/img/addrress_icon.png" alt="">
                            {{item[0].fullAddress}}
                        </div>
                        <div class="station-time">
                            <img src="@/assets/img/tips_icon.png" alt="">
                            期望送达时间 {{item[0].reachTime | formatTimestamp}}
                        </div>
                    </div>
                    <span class="icon-show-sub" @click="changeShow(index)">
                        {{goodShowList[index] ? '收起' : '订单详情'}}
                        <a-icon v-if="goodShowList[index]" type="caret-up" />
                        <a-icon v-else type="caret-down" />
                    </span>
                    <div v-if="goodShowList[index]" class="station-orders">
                        <div v-for="(end, i) in  item" :key="end.id">
                            <div class="order-info">
                                <div class="flex">
                                    <div class="flex order-info-container">
                                        <div class="info-order">
                                            <p>子单号：<span>{{end.odrNo}}</span></p>
                                        </div>
                                        <div class="info-order">
                                            <p>发货地：<span>{{end.startStation}}</span></p>
                                        </div>
                                    </div>
                                    <div class="order-info-container staus-container">
                                        <p>状态：
                                            <span>
                                                {{filterText(end.status)}}
                                                <span v-track-click="{ trackName: '纯运输-查看明细（D）' }" class="viewDetails" @click="checkLogs(end)">
                                                    <a-icon class="eye-icon" type="eye" />
                                                    查看明细
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="flex action-button">
                                <!-- D订单状态=“待处理”or“待派车”or“待提货”or“运输中” -->
                                <a-tooltip
                                    v-if="[DSTATUSCODE.TO_BE_DISPATCH, DSTATUSCODE.TO_BE_START, DSTATUSCODE.TO_BE_SIGN].includes(end.status) && (!end.upAddType || end.upAddType === 1)"
                                    title="同一个订单只允许申请一次收货地变更，请仔细核对信息"
                                >
                                    <a-button
                                        icon="edit"
                                        @click="editAddress(end)"
                                    >
                                        修改收货地址
                                    </a-button>
                                </a-tooltip>
                                <!-- 订单站点修改审核通过并且处理成功 -->
                                <div v-if="(end.upAddType === 2)">
                                    <span class="tag">已改收货地址</span>
                                    <a-button
                                        type="link"
                                        @click="detailAddress(end)"
                                    >
                                        查看原地址<a-icon type="right" />
                                    </a-button>
                                </div>
                                <a-button
                                    v-if="(!orderDetail.ext || !orderDetail.ext.demoData) && negotiationType !== NEGOTIABLE && [DSTATUSCODE.TO_BE_SUBMITTED, DSTATUSCODE.TO_BE_DISPATCH, DSTATUSCODE.ABNORMAL].includes(end.status)"
                                    @click="cancelOrder(end)"
                                >
                                    取消订单
                                </a-button>
                            </div>
                            <a-table
                                :columns="goodsTableColums"
                                :data-source="goodsList(end.stationGoodsList)"
                                :pagination="false"
                                bordered
                                class="goods-table table-multip">
                                <template slot="goosInfo" slot-scope="text, rowData">
                                    <p>{{filterSumText(rowData.goodsInfo)}}</p>
                                    <p>{{filterWeightText(rowData.goodsInfo)}}</p>
                                </template>
                                <template slot="temperatureZone" slot-scope="text">
                                    <p>{{filterTemp(text)}}</p>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
            </div>
        </block-title>
        <status-modal ref="statusModal" />
        <edit-address ref="editAddress" @success="editSuccess" />
        <original-address ref="originalAddress" />
    </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import {goodsTableColums} from '../tableColums.js'
import { cancelFullOrder } from '../../api.js';
import StatusModal from '../../components/StatusModal.vue'
import { OrderStatusCode, minGroupSize, UnifyOrderStatus, ORDERSTATUS,OrderStatusList, DSTATUSCODE, NEGOTIABLE } from '../../constant';
import EditAddress from './EditAddress.vue'
import OriginalAddress from './OriginalAddress.vue'

const TempType = {
    '常温': '常温（环境温度）',
    '冷藏': '冷藏（0°C〜6°C）',
    '冷冻': '冷冻（-18°C以下）',
    '恒温': '恒温（15°C〜20°C）',
}

export default {
    name: 'OrderAddress',
    components: {
        StatusModal,
        BlockTitle,
        EditAddress,
        OriginalAddress,
    },
    props: {
        negotiationType: {
            type: String,
            default: ''
        }, // 议价
        orderDetail: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            goodsTableColums,
            groupSize: 0,
            OrderStatusCode,
            minGroupSize,
            logList: [],
            UnifyOrderStatus,
            ORDERSTATUS,
            OrderStatusList,
            DSTATUSCODE,
            NEGOTIABLE,
            startShow: true,
            endShow: true,
            startStation: [],
            endStations: [],
            goodShowList: [],
        }
    },
    watch: {
        orderDetail: {
            handler(val){
                this.startStation = val.startStations || [];
                const startStationParams = {};
                this.startStation.forEach((item) => {
                    startStationParams[item.stationId] = item.stationName;
                });
                const { endStations } = val;
                endStations.map((item) => {
                    item.map((station) => {
                    const end = station;
                    const stationId = end.stationGoodsList[0]?.startStationId;
                    end.startStation = startStationParams[stationId];
                    return end;
                    });
                    return item;
                });
                this.endStations = val.endStations;
                const len = val.endStations.length;
                this.goodShowList = Array(len).fill(len < 4);
            },
            immediate: true
        },
    },
    mounted () {
    },
    methods: {
        editSuccess() {
            this.$emit('cancel')
        },
        onStartShow() {
            this.startShow = !this.startShow
        },
        onEndShow() {
            this.endShow = !this.endShow
        },
        changeShow(index) {
            const show = this.goodShowList[index]
            this.$set(this.goodShowList, [index],  !show)
        },
        cancelOrder(station) {
            this.$confirm({
                content: `确认取消【目的地：${station.fullAddress}】的子订单?`,
                confirmLoading: false,
                onOk: () => {
                    return new Promise((resolve) => {
                        cancelFullOrder({
                            odrNos: [station.odrNo],
                            reason: '货主端取消',
                        }).then(() => {
                            this.$message.success('取消成功')
                            resolve()
                            setTimeout(() => {
                                this.$emit('cancel')
                            }, 1000);
                        }).catch(() => {
                            resolve()
                        })
                    })
                }
            })
        },
        // 记录详情
        detailAddress(row) {
            this.$refs.originalAddress.onShow(row)
        },
        // 修改收货地址
        editAddress(row) {
            this.$refs.editAddress.onShow(row)
        },
        filterText(data){
            return `${OrderStatusList[data]}`
        },
        filterSign(data) {
            let statusClass = '';
            let label = '';
            const cancelList = data.filter(item => item.status === DSTATUSCODE.CANCELED)
            const noSignList = data.filter(item => item.status !== DSTATUSCODE.BALANCE_CHECK)
            if (cancelList.length === data.length) {
                statusClass = 'cancel-status'
                label = '已取消'
            } else if (!noSignList.length) {
                statusClass = 'done'
                label = '已签收'
            } else {
                label = '未签收'
            }
            return {
                statusClass,
                label
            }
        },
        goodsList(data) {
            if (!data) return []

            return data.map(item => {
                return {
                    key: item.skuId,
                    goodsName: item.skuName,
                    temperatureZone: item.temperatureZone,
                    skuValue: item.goodsValue || '--',
                    goodsInfo: {
                        skuSum: item.number,
                        skuUnit: item.ext?.goodsUnit || item.ext?.goodUnit,
                        weightTon: item.weight,
                        volume: item.volume
                    }
                }
            })
        },
        async checkLogs(data) {
            const unifyOrderNo = data.odrNo
            // this.logList = await featchOrderLogs({
            //     bizNo: unifyOrderNo,
            //     BizType: 'CUSTOMER_ORDER_NODE_LOG',
            //     logo: 'logDetail',
            // })
            this.$refs.statusModal.show(unifyOrderNo)
        },
        filterTemp(data){
            return data?.includes('~') ? `自定义温度（${data}）℃` : TempType[data];
        },
        filterNumber(number){
            return number || 0
        },
        filterSumText(data){
            if (data.skuSum) {
                return `共${data.skuSum}${data.skuUnit || '件'}`
            }
            return ''
        },
        filterWeightText(data){
            const weight = this.filterNumber(data.weightTon)
            const volume = this.filterNumber(data.volume)
            if (weight && volume) {
                return `共${weight}kg/${volume}M³`
            }
            if (weight && !volume) {
                return `共${weight}kg`
            }
            if (!weight && volume) {
                return `共${volume}M³`
            }
            return ''
        }
    },
}
</script>

<style lang="less" scoped>
.OrderAddress-root {
    // padding: 32px 0;
    // background: #fff;
    .block-title {
        background: #fff;
        padding: 24px;
        ::v-deep .label {
            margin-bottom: 16px;
        }
    }
    .flex {
        display: flex;
    }
    .origin-station {
        /deep/ .icon {
            background: #06B880;
        }
        .station-name {
            &::before {
                background: #06B880;
            }
        }
    }
    .icon-show {
        color: #606266;
        margin: 0 36px 0 8px;
        cursor: pointer;
    }
    .icon-show-sub {
        margin-top: 16px;
        display: inline-block;
        color: #06B880;
        cursor: pointer;
    }
    .end-station{
        // padding-top: 20px;
        margin-top: 16px;
        /deep/ .icon {
            background: #FB9432;
        }
        .station-name {
            &::before {
                background: #FB9432;
            }
        }
    }
    .station-info {
        // padding: 0 52px;
        padding: 0 16px 24px 16px;
        position: relative;
        // margin-bottom: 24px;
        &:not(:first-of-type) {
            padding-top: 24px;
            padding-bottom: 0;
            &::before {
                position: absolute;
                content: '';
                display: inline-block;
                width: calc(100% - 32px);
                height: 1px;
                background: #E6EAF0;
                top: 0;
                left: 16px;
            }
        }
        .station-status {
            .status {
                margin-left: 8px;
                display: inline-block;
                font-size: 12px;
                height: 24px;
                line-height: 24px;
                background: #E6F7F2;
                color: #06B880;
                border-radius: 2px;
                border: 1px solid #C3E8E1;
                padding: 0 10px;
            }
            .abnormal {
                background: #ED4934;
            }
            .done {
                background: #F4F5F6;
                color: #171717;
                border: 1px solid #CDD2DA;
            }
            .cancel-status {
                background: #EBEDF0;
                color: #909399;
            }
        }
        .station-name {
            font-size: 16px;
            position: relative;
            padding-left: 16px;
            &::before {
                content: '';
                width: 8px;
                height: 8px;
                border-radius: 50%;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        .station-container {
            margin-top: 16px;
            justify-content: space-between;
            img {
                width: 16px;
                height: 16px;
            }
        }
        .station-orders {
            color: #7E8694;
            > div {
                background: #F0F2F5;
                border: 1px solid #E6EAF0;
                padding: 20px;
                margin-top: 16px;
                border-radius: 4px;
            }
            .order-info {
                justify-content: space-between;
                align-items: center;
                .order-info-container {
                    flex: 3;
                    &.staus-container {
                        flex: 1;
                    }
                    .info-order {
                        flex: 1;
                        margin-right: 16px;
                    }
                    p {
                        span {
                            color: #1C2026;
                            margin-top: 8px;
                        }
                        .viewDetails {
                            color: #06B880;
                            cursor: pointer;
                            .eye-icon {
                                margin-left: 24px;
                            }
                        }
                    }
                }
            }
            .action-button {
                margin-top: 20px;
                justify-content: space-between;
                .tag {
                    display: inline-block;
                    padding: 5px 12px;
                    background: #E6EAF0;
                    border: 1px solid #CDD2DA;
                    border-radius: 2px;
                    color: #505762;
                    line-height: 22px;
                    margin-right: 8px;
                }
                ::v-deep .ant-btn-link {
                    padding: 0;
                }
            }
            .goods-table {
                margin-top: 16px;
                /deep/ .ant-table-thead > tr > th {
                    background: #FAFBFC !important;
                }
                /deep/ .ant-table-tbody .ant-table-row  {
                    background: #fff;
                }
            }
        }
    }
}
</style>